import React from 'react';

type Props = React.HTMLProps<HTMLParagraphElement> & {
  children: React.ReactNode;
  /**
   * @deprecated
   */
  'data-qa'?: string;
};

export const FormValidationError = (props: Props) => {
  const { 'data-qa': dataQa, children, className, ...restProps } = props;
  return (
    <div
      data-qa={dataQa}
      className={`text-red-100 bg-red-600 bg-opacity-50 text-sm font-sans inline-block px-2 py-1 rounded-sm ${className}`}
      {...restProps}
    >
      {children}
    </div>
  );
};
